import "./styles.scss";

import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { useClients } from "context/admin/clients";

import ModalMobile from "components/ModalMobile";
import Button from "components/Button";
import Select from "components/form/Select";

import website_status_data from "libs/website_status_data.json";

import { ReactComponent as GreenStatusIcon } from "assets/icons/green-status.svg";
import { ReactComponent as RedStatusIcon } from "assets/icons/red-status.svg";
import { ReactComponent as BlueStatusIcon } from "assets/icons/blue-status.svg";
import { ReactComponent as OrangeStatusIcon } from "assets/icons/orange-status.svg";

const mainClass = "clients-admin-modal-filters";
const initialFilters = { status: null };

const statusIconRender = (status) => {
  switch (status) {
    case 1:
      return <GreenStatusIcon />;
    case 2:
      return <RedStatusIcon />;
    case 3:
      return <BlueStatusIcon />;
    case 4:
      return <OrangeStatusIcon />;
    default:
      return null;
  }
};

const ClientsModalFilters = ({ isOpen, onClose }) => {
  const { t } = useTranslation();
  const { filters, applyFilters, filterClearAll } = useClients();
  const [draft, setDraft] = useState(initialFilters);
  const [appliedFilters, setAppliedFilters] = useState(initialFilters);

  useEffect(() => {
    if (isOpen) {
      const status = filters?.status?.split(",")?.[0];
      const snapshot = {
        status: website_status_data.find((item) => item.key === status) || null,
      };

      setDraft(snapshot);
      setAppliedFilters(snapshot);
    } else {
      setDraft(initialFilters);
      setAppliedFilters(initialFilters);
    }
  }, [filters, isOpen]);

  const isDirty = draft.status?.key !== appliedFilters.status?.key;

  return (
    <ModalMobile hasMobileScrollTop={false} isOpen={isOpen} onClose={onClose}>
      <div className={mainClass}>
        <Select
          label={t("Status")}
          placeholder={t("Select status")}
          options={website_status_data.map((item) => ({
            ...item,
            icon: statusIconRender(item.value),
            label: t(item.label),
          }))}
          selected={draft.status}
          value={draft.status?.value}
          forceBottom
          onChange={(option) => setDraft({ status: option })}
        />
        <div className={`${mainClass}__actions`}>
          <Button
            disabled={!draft.status}
            onClick={() => {
              filterClearAll();
              setDraft(initialFilters);
              setAppliedFilters(initialFilters);
            }}
          >
            {t("Remove filters")}
          </Button>
          <Button
            disabled={!isDirty}
            onClick={() => {
              applyFilters(draft);
              onClose();
            }}
          >
            {t("Apply filters")}
          </Button>
        </div>
      </div>
    </ModalMobile>
  );
};

export default ClientsModalFilters;
